<template>
<div>
  <md-dialog :md-active.sync="_showUseTemplateDialog" v-if="isLoaded">
    <md-dialog-title>導入服務範本</md-dialog-title>
    <md-dialog-content>
      <md-tabs>
        <md-tab md-label="選擇服務範本">
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field>
                <label>範本分類</label>
                <md-select v-model="selectedGroup">
                  <md-option v-for="group in groups" :groups="groups" :key="group.id" :value="group.id">
                    {{group.name}}
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </div>
          <md-table>
            <md-table-row>
              <md-table-head>名稱</md-table-head>
            </md-table-row>
            <md-table-row v-for="template in templates" :key="template.id">
              <md-table-cell>
                <a @click="$emit('useTemplate', template.id)">
                  {{template.name}}
                </a>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-tab>
      </md-tabs>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button class="md-primary" @click="$emit('close')">關閉</md-button>
    </md-dialog-actions>
  </md-dialog>
</div>
</template>

<script>
import axios from 'axios'
import urls from '@/urls'

export default {
  props: ['showUseTemplateDialog'],
  data () {
    return {
      selectedGroup: null,
      templates: [],
      groups: [],
      isLoaded: false
    }
  },
  components: {
  },
  created: async function () {
    await this.getGroups()
    this.isLoaded = true
  },
  watch: {
    selectedGroup: function (val) {
      this.getTemplates(val)
    }
  },
  computed: {
    _showUseTemplateDialog: {
      get: function () {
        return this.showUseTemplateDialog
      },
      set: function (val) {
        if (!val) {
          this.$emit('close')
        }
      }
    }
  },
  methods: {
    async getTemplates (groupID) {
      let result = await axios.get(urls({route: `record-template-group/${groupID}/record-template`}))
      this.templates = result.data.data
    },
    async getGroups () {
      let result = await axios.get(urls({route: 'record-template-group'}))
      this.groups = result.data.data
    }
  }
}
</script>

<style>
.md-menu-content {
  z-index: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/Record/UseTemplate.vue